import React, { useState, useEffect } from 'react';
import { collection, doc, setDoc, updateDoc, deleteDoc, onSnapshot } from 'firebase/firestore';
import { db, auth } from './firebaseConfig';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { Container, TextField, Button, Select, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AlertComponent from './AlertComponent';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ email: '', password: '', role: 'normal' });
  const [alert, setAlert] = useState({ open: false, message: '', type: '' });

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'users'), (snapshot) => {
      setUsers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => unsub();
  }, []);

  const handleCreateUser = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, newUser.email, newUser.password);
      await setDoc(doc(db, 'users', userCredential.user.uid), { email: newUser.email, role: newUser.role });
      setAlert({ open: true, message: 'Usuario creado exitosamente', type: 'success' });
      setNewUser({ email: '', password: '', role: 'normal' });
    } catch (error) {
      setAlert({ open: true, message: error.message, type: 'error' });
    }
  };

  const handleUpdateRole = async (id, newRole) => {
    try {
      await updateDoc(doc(db, 'users', id), { role: newRole });
      setAlert({ open: true, message: 'Rol actualizado exitosamente', type: 'success' });
    } catch (error) {
      setAlert({ open: true, message: error.message, type: 'error' });
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      await deleteDoc(doc(db, 'users', id));
      setAlert({ open: true, message: 'Usuario eliminado exitosamente', type: 'success' });
    } catch (error) {
      setAlert({ open: true, message: error.message, type: 'error' });
    }
  };

  return (
    <Container sx={{ mt: 8 }}>
      <TextField
        label="Email"
        value={newUser.email}
        onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Contraseña"
        type="password"
        value={newUser.password}
        onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
        fullWidth
        margin="normal"
      />
      <Select
        value={newUser.role}
        onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
        fullWidth
      >
        <MenuItem value="readonly">Solo lectura</MenuItem>
        <MenuItem value="normal">Normal</MenuItem>
        <MenuItem value="admin">Administrador</MenuItem>
      </Select>
      <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleCreateUser}>Crear Usuario</Button>

      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Rol</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map(user => (
              <TableRow key={user.id}>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <Select value={user.role} onChange={(e) => handleUpdateRole(user.id, e.target.value)}>
                    <MenuItem value="readonly">Solo lectura</MenuItem>
                    <MenuItem value="normal">Normal</MenuItem>
                    <MenuItem value="admin">Administrador</MenuItem>
                  </Select>
                </TableCell>
                <TableCell align="right">
                  <IconButton color="error" onClick={() => handleDeleteUser(user.id)}><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AlertComponent
        open={alert.open}
        message={alert.message}
        type={alert.type}
        handleClose={() => setAlert({ ...alert, open: false })}
      />
    </Container>
  );
};

export default UserManagement;
